import BaseProxy from './BaseProxy';

class Image extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/image', parameters);
    }
}

export default Image;



// WEBPACK FOOTER //
// ./src/api/Image.js